'use strict';

angular.module('shiftTraderApp')
  .factory('WorkPeriods', function (ServerUrls, $http, $q, $log, $injector, Session) {
    var nodePath = ServerUrls.current.nodeApi.slice(0, -3) + 'v2/work_periods/';

    // WORKPERIOD MODEL OBJECT
    var WorkPeriod = function(initData) {
      var wp = {};

      wp.$reinitialize = function(data) {
        _.merge(wp, data);
        wp._type = 'workPeriod';
        wp.start_time = moment.utc(data.start_time).tz(Session.getTimezone());
        wp._startTimeUnix = wp.start_time.unix();
        wp.end_time = moment.utc(data.end_time).tz(Session.getTimezone());
        wp._endTimeUnix = wp.end_time.unix();
        wp.range_twix = wp.start_time.twix(wp.end_time);
        wp._lengthInHours = Math.abs(wp.range_twix.length('minutes') / 60.0);
        wp._intoNextDay = wp.start_time.day() !== wp.end_time.day() && (wp.end_time.minutes() + wp.end_time.hours()) > 0;

        if (wp.published_time) {
          wp.published_time = moment.utc(data.published_time).tz(Session.getTimezone());
        }

        if (_.has(wp, 'position') && !_.has(wp, 'position_id')) {
          wp.position_id = wp.position.id;
        }

        if (!_.has(wp, 'related_trades') || _.isNull(wp.related_trades) || _.isUndefined(wp.related_trades)) {
          wp.related_trades = [];
        }

        if (!_.has(wp, 'department_id') && !_.has(wp, 'department')) {
          wp.department_id = null;
        }
        var ShiftTradesResource = $injector.get('ShiftTradesResource');

        if (wp.related_trades.length > 0) {
          var theTrade;
          wp.related_trades = _.map(wp.related_trades, function(trade) {
            theTrade = new ShiftTradesResource(trade);
            return theTrade.$initialize();

          });
        }
      };

      //actually call the initializer
      wp.$reinitialize(initData);

      wp.$toggleLock = function() {
        var localThis = this;
        this.$update({locked: !this.locked})
          .then(function(resp) {
            localThis.locked = resp.data.locked;
          });
      };

      wp.$calcPercentWorked = function() {
        //normalize now, end, start times
        var offset = wp.start_time.unix();
        var length = wp.end_time.unix() - offset;
        var secondsWorked = moment.utc().tz(Session.getTimezone()).unix() - offset;

        if (secondsWorked > 0) {
          return secondsWorked / length * 100;
        } else {
          return 0;
        }
      };

      wp.$update = function(newData) {
        var data = {id: this.id};
        angular.extend(data, newData);

        return $http.put(ServerUrls.current.railsApi + 'work_periods/' + this.id, data )
          .then(function (response) {
            console.log(response);
            return new WorkPeriod(response.data);
          });
      };

      wp.$shortStartTime = function() {
        if (this.start_time.minutes() === 0) {
          return this.start_time.format('h') + this.start_time.format('a')[0];
        } else {
          return this.start_time.format('h:mm') + this.start_time.format('a')[0];
        }
      };


      wp.$shortEndTime = function() {
        if (this.end_time.minutes() === 0) {
          return this.end_time.format('h') + this.end_time.format('a')[0];
        } else {
          return this.end_time.format('h:mm') + this.end_time.format('a')[0];
        }
      };

      wp.$isAssigned = function() {
        return (!_.isUndefined(this.user_id) && !_.isNull(this.user_id)) || (!_.isUndefined(this.user) && !_.isNull(this.user));
      };

      wp.$isBeingTraded = function() {
        return this.related_trades.length > 0 && this.$hasActiveTrade();
      };

      wp.$getActiveTrade = function() {
        return _.find(this.related_trades, function(trade) {
          return trade.$calculateActive(true);
        });
      };

      wp.$hasActiveTrade = function() {
        return _.any(_.map(this.related_trades, function(trade) {
          return trade.$calculateActive(true);
        }));
      };

      wp.$isInvolvedInTrade = function(usr) {
        // is the passed in 'usr' in the first trade in the related_trades array
        if (this.related_trades.length === 0) {
          return false;
        }
        var activeTrade = this.$getActiveTrade();
        if (_.isUndefined(activeTrade) || _.isNull(activeTrade)) {
          return false; // no active trade for this work period
        } else {
          // there is an active trade
          // check if usr is involved
          var answer = false;

          if (_.has(activeTrade, 'trade_user') && !_.isNull(activeTrade.trade_user) && !_.isUndefined(activeTrade.trade_user) ) {
            answer = answer || activeTrade.trade_user.id === usr.id;
          }

          if (activeTrade.user.id === usr.id) {
            answer = true;
          }

          if (angular.isDefined(activeTrade.shift_trade_responses)) {
            answer = answer || _.any(activeTrade.shift_trade_responses, function(resp) {
              if (_.has(resp, 'user_id')) {
                return usr.id === resp.user_id && _.include([10, 11], resp.acceptance_code);
              } else {
                return usr.id === resp.user.id && _.include([10, 11], resp.acceptance_code);
              }
            });
          }
          return answer;
        }
        return false; // just in case we didn't hit anything else
      };

      wp.$isInThePast = function() {
        var now = moment().tz(Session.getTimezone());
        return this.start_time.isBefore(now);
      };

      wp.$isQualifiedForPickup = function(usr) {
        // verify that the usr has the same position as the work_period
        // TODO: verify that the usr is not already working during this work_period
        return _.any(usr.users_positions, function(up) {
          return up.position_id === wp.position.id && wp.$isPublished();
        });
      };

      wp.$isPublished = function() {
        //console.log(this);
        //console.log(_.isNull(this.published_by_id));
        //console.log(_.isUndefined(this.published_by));
        //console.log(_.isUndefined(this.published_by_id));
        //console.log(_.isNull(this.published_by));

        return (!_.isNull(this.published_by_id) && _.isUndefined(this.published_by)) || (!_.isNull(this.published_by) && _.isUndefined(this.published_by_id))
            || (this.published_by_id && this.published_by);
      };

      return wp;
    };

    //WORKPERIODS CREATE/QUERY LAYER
    var WorkPeriods = {};
    WorkPeriods.getByUserId = function (userId, data) {
      var config = {
        params: {
          'user_id': userId
        }
      };

      if (angular.isDefined(data)) {
        angular.extend(config.params, data);
      }

      return $http.get(nodePath, config)
        .then(function (response) {
          return _.map(response.data, function(wp) {
            return WorkPeriods.initWithData(wp);
          });
        }, function(response) {
          return $q.reject(response);
        });
    };

    WorkPeriods.create = function (workPeriod) {
      // start_time
      // end_time
      // organization_id
      // position_id
      // user_id

      return $http.post(ServerUrls.current.railsApi + 'work_periods', workPeriod )
        .then(function (response) {
          return WorkPeriods.initWithData(response.data);
        },
        function(response) {
          console.log('workPeriod create failed!');
          return $q.reject(response);
        });
    };


    WorkPeriods.getById = function (id) {
      return $http.get(ServerUrls.current.railsApi + 'work_periods/' + id)
        .then(function (response) {
          return WorkPeriods.initWithData(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    WorkPeriods.getAll = function (params, raw) {
      var config = {
        params: {
          'organization_id': Session.getCurrentOrgId()
        }
      };

      if (angular.isDefined(params)) {
        angular.extend(config.params, params);
      }

      var baseUrl;
      if (_.has(params, 'mode') || _.has(params, 'recent_mode')) {
        baseUrl = ServerUrls.current.railsApi + 'work_periods/';
      } else {
        baseUrl = nodePath;
      }

      return $http.get(baseUrl, config)
        .then(function (response) {
          if (raw) {
            return response.data;
          } else {
            return _.map(response.data, function(wp) {
              return WorkPeriods.initWithData(wp);
            });
          }
        }, function(response) {
          return $q.reject(response);
        });
    };

    WorkPeriods.initWithData = function(initData) {
      return new WorkPeriod(initData);
    };

    return WorkPeriods;
  });
